<section [ngClass]="dynamicClass">
<div class="eq-container eq-mt-[132px] lg:eq-mt-15" [ngClass]="{'lg:eq-mb-[751px]': showImage}">
  <div class="lg:eq-bg-white lg:eq-relative eq-block-page-title-pseudo-background" [ngClass]="{'lg:eq-pb-[171px]': showImage}">
    <div class="eq-flex eq-flex-col eq-gap-[40px] lg:eq-gap-[60px] lg:eq-pt-[60px]" [ngClass]="{'eq-pb-[100px]': rendering.fields?.WithoutBreadcrump.value}">
      <div class="eq-flex eq-flex-col eq-gap-6 lg:eq-w-[77%] lg:eq-mx-auto">
        <h1 class="eq-text-heading1-m lg:eq-text-heading1 eq-text-blue-darkBlue eq-font-bold eq-text-center lg:eq-text-left" *scText="rendering.fields.Title"></h1>
        <div class="eq-text-body-subtitle-m lg:eq-text-body-subtitle eq-text-black-natural-80" *scText="rendering.fields.Subtitle"></div>
        <a *ngIf="rendering?.fields?.Link?.value?.href" hybridHref href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}" class="eq-btn eq-btn-primary eq-w-full md:eq-w-fit">{{rendering?.fields?.Link?.value?.text}}</a>
      </div>
      <div *ngIf="!rendering.fields?.WithoutBreadcrump.value" class="eq-flex eq-justify-end lg:eq-justify-between eq-py-4 lg:eq-py-5 lg:eq-w-[77%] lg:eq-mx-auto">
        <div class="eq-breadcrumb eq-hidden md:eq-block">
          <ul>
            <li *ngFor="let item of rendering.fields?.result?.Items; let i = index; first as isFirst; last as isLast">
              <ng-container *ngIf="!isLast;else onlyText">
                <a hybridHref href="{{item.href}}" attr.aria-label="{{item.text}}">{{item.text}}</a><span class="eq-px-2">|</span>
              </ng-container>
              <ng-template #onlyText>
                {{item.text}}
              </ng-template>
            </li>
          </ul>
        </div>
        <div class="eq-flex eq-gap-4">
          <button onclick="window.print();"><i class="eq-icons eq-icon-download eq-text-[24px]"></i></button>
          <button (click)="navigatorShare()"><i class="eq-icons eq-icon-share eq-text-[24px]"></i></button>
        </div>        
      </div>
    </div>
    <div *ngIf="rendering.fields?.Image?.value != ''">
      <ng-container *ngIf="!isMobile">
        <img class="lg:eq-absolute eq-h-[225px] lg:eq-h-[672px] lg:eq-w-[90%] lg:eq-left-[5%] eq-object-cover" *scImage="rendering.fields?.Image">
      </ng-container>
      <ng-container *ngIf="isMobile">
        <img class="eq-h-[225px] eq-object-cover" *scImage="rendering.fields?.MobileImage">
      </ng-container>
    </div>
  </div>
</div>
</section>